var map = {
	"./registration/data-guaranteed.png": "a550",
	"./registration/email-sent.png": "92ce",
	"./registration/otp-success.png": "3517",
	"./registration/quotes-1.png": "e673",
	"./registration/quotes-2.png": "2c8a",
	"./registration/quotes-3.png": "7f5b",
	"./registration/registration-step1.png": "1405",
	"./registration/registration-success.png": "39b4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";